<template>
    <section v-if="breadcrumbs && breadcrumbs.length" class="breadcrumb">
        <div class="container-fluid">
            <ul class="breadcrumb-list" itemscope itemtype="https://schema.org/BreadcrumbList">
                <li class="breadcrumb-item breadcrumb-item--home"
                    itemprop="itemListElement"
                    itemscope
                    itemtype="https://schema.org/ListItem">
                    <a rel="nofollow" class="breadcrumb-link" href="/" itemprop="item" title="Главная">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64px" height="64px"
                             viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
                            <path d="M32.023,4L59,24.811V60H42V36H22v24H5V24.811L32.023,4 M32.024,1.475L3,23.827V62h21V38h16v24h21V23.828 L32.024,1.475L32.024,1.475z"/>
                        </svg>
                        <meta itemprop="name" content="Главная">
                    </a>
                    <meta itemprop="position" content="1">
                </li>

                <template v-for="(breadcrumb, index) in breadcrumbs">
                    <li class="breadcrumb-item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                        <a v-if="breadcrumb.url" class="breadcrumb-link" :href="breadcrumb.url" itemprop="item" :title="breadcrumb.name">{{ breadcrumb.name }}</a>
                        <span v-else class="breadcrumb-link" itemprop="item">{{ breadcrumb.name }}</span>
                        <meta itemprop="name" :content="breadcrumb.name">
                        <meta itemprop="position" :content="index + 2">
                    </li>
                </template>
            </ul>
        </div>
    </section>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'CatalogBreadcrumbs',
        computed: {
            ...mapState('catalog', [
                'breadcrumbs',
                'sortOptions',
            ]),
            ...mapGetters('catalog', [
                'selectedSortOption',
            ])
        }
    }
</script>
